import { getAuthenticationHeader } from '@fenderdigital/custom-hooks/lib/cognito';
import fetch from '../core/fetch';
import config from '../config';
import AuthorizationHeader from './authorization-header';

export function getTabLevelSettings(level, instrument) {
  const settingsArr = config.tablatureLevelSettings;
  if (!level || Object.is(level, NaN) || level >= settingsArr.length) {
    return {};
  }
  if (!instrument || instrument.toLowerCase() !== 'bass') {
    return settingsArr[Number(level)];
  }
  return Object.assign(settingsArr[Number(level)], { chordDisplay: 'name' });
}

export default async function getTabData(file, token) {
  const url = `${process.env.REACT_APP_CLIENT_LIBRARY_API}/tabs-data/${encodeURIComponent(file)}`;
  let params = {};
  const authToken = await getAuthenticationHeader();
  if (token) {
    params = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json; version=3.1.0',
        Authorization: `Bearer ${token}`,
      },
    };
  } else if (authToken) {
    const headers = await AuthorizationHeader.getCognitoHeader();
    params = {
      method: 'GET',
      ...headers,
    };
  }
  const response = await fetch(url, params);
  return response.text();
}
